import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
interface HowToStepsProps {
  onOpenForm: () => void;
}
const HowToSteps = ({
  onOpenForm
}: HowToStepsProps) => {
  const [currentStep, setCurrentStep] = useState(1);
  const steps = [{
    id: 1,
    title: "Partagez votre brief en 2 minutes",
    image: "/lovable-uploads/97691f56-6471-4aa7-a4a8-cd8aa7419011.png",
    alt: "Collage d'activités",
    badge: {
      text: "2min",
      icon: Clock,
      position: "top-1/2 left-6 -translate-x-1/2 -translate-y-1/2"
    }
  }, {
    id: 2,
    title: "Recevez des propositions gratuites sous 24h",
    image: "/lovable-uploads/e8bc8bfa-8297-4cd0-b8aa-1359e5ce3f28.png",
    alt: "Propositions d'hôtels",
    badge: {
      text: "24h",
      icon: Clock,
      position: "top-4 -right-2"
    }
  }, {
    id: 3,
    title: "Bénéficiez d'un support professionnel jusqu'au jour J !",
    image: "/lovable-uploads/2f801313-46c5-418b-b05a-74df11467e3a.png",
    alt: "Support professionnel",
    badge: null
  }];

  // Observer for scroll position on mobile
  useEffect(() => {
    let rafId: number;
    let ticking = false;
    const handleScroll = (e: Event) => {
      if (!ticking) {
        rafId = requestAnimationFrame(() => {
          const carousel = e.target as HTMLElement;
          const cardWidth = carousel.offsetWidth;
          const scrollLeft = carousel.scrollLeft;
          const newStep = Math.round(scrollLeft / cardWidth) + 1;
          if (newStep !== currentStep && newStep >= 1 && newStep <= 3) {
            setCurrentStep(newStep);
          }
          ticking = false;
        });
        ticking = true;
      }
    };
    const carousel = document.getElementById('steps-carousel');
    if (carousel) {
      carousel.addEventListener('scroll', handleScroll);
      return () => {
        carousel.removeEventListener('scroll', handleScroll);
        if (rafId) {
          cancelAnimationFrame(rafId);
        }
      };
    }
  }, [currentStep]);
  return <section className="bg-white py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-normal mb-6">
            Planifiez vos événements en<br />3 étapes
          </h2>
        </div>
        
        {/* Desktop Version */}
        <div className="hidden md:grid md:grid-cols-3 gap-8 md:gap-16 mb-16">
          {steps.map((step, index) => <div key={step.id} className="relative bg-card-yellow p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center animate-fade-in" style={{
          animationDelay: `${index * 0.2}s`
        }}>
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-black text-white w-10 h-10 rounded-full flex items-center justify-center font-normal">
                {step.id}
              </div>
              <h3 className="text-xl font-normal mb-5 mt-4" dangerouslySetInnerHTML={{
            __html: step.title.replace(/\n/g, '<br />')
          }} />
              <div className="relative">
                <img src={step.image} alt={step.alt} className="w-64 h-64 rounded-lg object-contain" />
                {step.badge && <Badge className={`absolute ${step.badge.position} bg-[#C6E278] text-black px-3 py-2 text-sm font-semibold flex items-center gap-1`}>
                    <step.badge.icon size={14} />
                    {step.badge.text}
                  </Badge>}
              </div>
            </div>)}
        </div>

        {/* Mobile Version */}
        <div className="md:hidden mb-16">
          {/* Step Indicators */}
          <div className="flex justify-center gap-4 mb-8">
            {[1, 2, 3].map(step => <div key={step} className={`w-10 h-10 rounded-full flex items-center justify-center font-normal text-white transition-all duration-300 ${step === currentStep ? 'bg-black' : 'bg-gray-400'}`}>
                {step}
              </div>)}
          </div>

          {/* Scrollable Carousel */}
          <div id="steps-carousel" className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            {steps.map(step => <div key={step.id} className="flex-none w-full snap-center">
                <div className="bg-card-yellow p-6 rounded-2xl shadow-sm border border-gray-100 text-center mx-2">
                  <h3 className="text-lg font-normal mb-6 px-4">
                    {step.title}
                  </h3>
                  <div className="relative flex justify-center">
                    <img src={step.image} alt={step.alt} className="w-56 h-56 rounded-lg object-contain" />
                    {step.badge && <Badge className={`absolute ${step.badge.position} bg-[#C6E278] text-black px-3 py-2 text-sm font-semibold flex items-center gap-1`}>
                        <step.badge.icon size={14} />
                        {step.badge.text}
                      </Badge>}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        
        <div className="flex justify-center">
          <Button onClick={onOpenForm} className="bg-cta-green text-cta-green-foreground hover:bg-cta-green/90 hover:shadow-xl hover:shadow-cta-green/30 text-sm px-6 py-2 font-semibold rounded-md group transition-all duration-300 hover:scale-105">
            Lancer votre projet gratuitement
            
          </Button>
        </div>
      </div>
    </section>;
};
export default HowToSteps;